(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  var $list = $('.grid-view-item');
  $list.each(function(){
    $('input[name=color]').click(function() {
      var inputId = $(this).attr("data-vid");
      var targetImg = $("img[data-vid='" + inputId +"']");
      $(targetImg).show().siblings().hide();
    });
    if ( $(this).find('input[name=color][data-status="unavailable"]').is(':checked') === false ) {
        $(this).find('.button-available').show();
      }
    if ( $(this).find('input[name=color][data-status="available"]').is(':checked') === false ) {
        $(this).find('.button-unavailable').show();
      }
  }); 
  $('input[name=color]').on('change', function() {
    if ($(this).data('status') == 'available' ) {
      $(this).closest('.color-radios').nextAll('.button-available').show();
      $(this).closest('.color-radios').nextAll('.button-unavailable').hide();
    } 

    if ($(this).data('status') == 'unavailable' ) {
      $(this).closest('.color-radios').nextAll('.button-available').hide();
      $(this).closest('.color-radios').nextAll('.button-unavailable').show();
    }
  }); 
  
  // Get all product card elements
  const productCards = document.querySelectorAll('.product-card');
  
  // Loop through all product cards
  productCards.forEach(function(productCard) {
    // Get all radio buttons inside the product card
    const radioButtons = productCard.querySelectorAll('input[type="radio"]');
    
    // Loop through all radio buttons
    radioButtons.forEach(function(radio) {
      // Get the value of the data-vid attribute of the checked radio button
      const selectedVid = productCard.querySelector('input[type="radio"]:checked').getAttribute('data-vid');
      
      // Get all images with the class "grid-view-item__image" inside the product card
      const images = productCard.querySelectorAll('.grid-view-item__image[data-vid]');
      
      // Loop through all images
      images.forEach(function(image) {
        // Check if the data-vid attribute of the image matches the selectedVid
        if (image.getAttribute('data-vid') === selectedVid) {
          // Show the image with the matching data-vid attribute
          image.style.display = 'block';
        } else {
          // Hide images that do not match the selectedVid
          image.style.display = 'none';
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
